import { render, staticRenderFns } from "./pointage-scrollbar.vue?vue&type=template&id=3a3fca53&scoped=true&"
import script from "./pointage-scrollbar.vue?vue&type=script&lang=ts&"
export * from "./pointage-scrollbar.vue?vue&type=script&lang=ts&"
import style0 from "./pointage-scrollbar.vue?vue&type=style&index=0&id=3a3fca53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fca53",
  null
  
)

export default component.exports